/** Номенклатурні групи (одиниці обліку НЗВ) — для вибору у виробничих документах. */
import { api } from './client';

export interface NomenclatureGroup {
  id: string;
  code: string | null;
  name: string;
  external_source?: string | null;
}

export interface NomenclatureGroupPayload {
  name: string;
  code?: string | null;
}

export const nomenclatureGroups = {
  list: () =>
    api.get<NomenclatureGroup[]>('/refs/nomenclature-groups').then((r) => r.data),
  create: (payload: NomenclatureGroupPayload) =>
    api.post<NomenclatureGroup>('/refs/nomenclature-groups', payload).then((r) => r.data),
  update: (id: string, payload: Partial<NomenclatureGroupPayload>) =>
    api.patch<NomenclatureGroup>(`/refs/nomenclature-groups/${id}`, payload).then((r) => r.data),
  remove: (id: string) =>
    api.delete(`/refs/nomenclature-groups/${id}`).then(() => undefined),
};
